import React from "react";
import { Route, Routes } from "react-router-dom";

import ReportLayout from "./ReportLayout";
import SystemReportsTab from "./SystemReportsTab";

const Reports = () => {
  return (
    <Routes>
      <Route element={<ReportLayout />}>
        <Route index element={<SystemReportsTab />} />
      </Route>
    </Routes>
  );
};

export default Reports;
